import { useEffect, useState } from 'react';

import useLADClaimsRegionList from '../../../redux/hooks/useLADClaimsRegionList';
import FormSelectBox from '../Inputs/FormSelectBox';

const LADClaimsRegionSelector = ({
  placeholder = 'Select Region',
  label = 'Region',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  disableValidation = false,
  divisionKey,
}) => {
  const [options, setOptions] = useState([]);
  const regionList = useLADClaimsRegionList(divisionKey);

  useEffect(() => {
    if (regionList?.length >= 0) {
      const options = regionList.map((row) => ({
        label: row.regionDesc,
        value: row.regionKey,
      }));
      setOptions(options);
    } else {
      setOptions([]);
    }
  }, [regionList]);

  return (
    <FormSelectBox
      loading={regionList === undefined}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
    />
  );
};

export default LADClaimsRegionSelector;
